import ErrorBase from './ErrorBase'

class RequestError extends ErrorBase {
  constructor(message: string) {
    super({ code: '320100', message, type: 'RequestError' })
  }
}

export default RequestError
